export type MaintenanceNoticeBody = string | null;

// APIの値が想定外の型・空白だけの場合も、表示しない（null）に倒す。
// 本文の正規化（改行・前後の空白）はサーバーで済んでいるので、ここでは表示するかどうかだけを判定する。
export const normalizeMaintenanceNoticeBody = (value: unknown): MaintenanceNoticeBody =>
  typeof value === "string" && value.trim() !== "" ? value : null;
